'use strict';

import { flow, observable, configure, action, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import {States} from './AppConstants';
import appStore from './AppStore';

/**
 * Store for banner messages.
 */
class BannerMessagesStore {

    state = States.initial;
    formData = {};

    constructor() {
        makeObservable(this, {
            state: observable,
            formData: observable,
            updateFormData: action
        });

        this.bannerMessages = {};
    }

    updateFormData(property, newValue) {
        this.formData[property] = newValue;
    }

    loadBannerMessages = flow(function* () {
        let url = 'api/banner/bannerMessages';
        let operationName = "getBannerMessages";

        this.state = States.pending;
        try {
            this.bannerMessages = yield appStore.getHttpClient().doGet(url, operationName);
            if (appStore.isDebug()) {
                console.log("BannerMessageStore:loadBannerMessages completed loading banner messages")
            }
            this.formData = this.bannerMessages;
            this.state= States.done;
        }
        catch (error) {
            console.log(error);
            this.state = States.error;
        }
    }.bind(this));

    updateBannerMessages = flow(function* () {
        let url = 'api/banner/bannerMessages';
        let operationName = "updateBannerMessages";

        this.state = States.pending;
        try {
            this.bannerMessages = yield appStore.getHttpClient().doPost(url, this.formData, operationName);
            if (appStore.isDebug()) {
                console.log("BannerMessageStore:updateBannerMessages completed loading banner messages")
            }
            this.state= States.done;
        }
        catch (error) {
            console.log(error);
            this.state = States.error;
        }
    }.bind(this));

    getBannerMessages() {
        return this.bannerMessages;
    }
}

export default new BannerMessagesStore();
